import React, { ReactNode } from 'react';
import { Box, Group } from '@mantine/core';
import { Sidebar } from './sidebar/Sidebar';
import { SidebarItem } from './sidebar/types';

type PageWithSidebarProps = {
  links: SidebarItem[];
  activeUrl: string;
  children: ReactNode;
};

export default function PageWithSidebar({ links, activeUrl, children }: PageWithSidebarProps) {
  return (
    <Group gap="xxl" align="flex-start" wrap="nowrap">
      <Sidebar links={links} activeUrl={activeUrl} />
      <Box style={{ flex: 1 }}>{children}</Box>
    </Group>
  );
}
